import intl from 'react-intl-universal';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '@/config';

const intiTimeZoneStr = (val) => {
  return val ? `(UTC${moment(val).format('Z')})` : '';
};

/**
 *
 * @param date
 * @param format
 * @returns
 */
const intlFormatDate = (date, format) => {
  let fm = format;
  if (typeof fm === 'string') {
    const propsName = fm;
    fm = (item) => (item ? moment(item).format(propsName) : '-');
  }
  return fm(date);
};
/*
 * format Date
 * @params date: date string
 * @params fmt: YYYY-MM-DD HH:mm:ss
 * return: formatted date string
 */
const formatDate = (date: string | number, fmt = DATE_TIME_FORMAT) => {
  if (typeof date !== 'string' && typeof date !== 'number') return '';

  return moment(date).format(fmt);
};

const addZero = (value) => {
  if (value === 0) return '00';
  return value >= 10 ? `${value}` : `0${value}`;
};

/*
 * format Date
 * @params seconds: seconds string
 * return: string HH:mm:ss
 */
const seconds2Time = (seconds: string) => {
  if (!seconds) return '';

  const tmp = +seconds;
  const h = 60 * 60;
  const m = 60;
  const hour = Math.floor(tmp / h);
  const minute = Math.floor((tmp % h) / m);
  const second = Math.floor((tmp % 3600) % 60);
  return `${addZero(hour)}:${addZero(minute)}:${addZero(second)}`;
};

/*
 * format Date
 * @params seconds: seconds string
 * return: string mm分ss秒
 */
const seconds2Minute = (seconds: number) => {
  if (seconds === 0) return '';

  const minute = Math.floor(seconds / 60);
  const second = Math.floor(seconds % 60);

  return minute > 0
    ? `${addZero(minute)}${intl.get('utils_mins')}${addZero(second)}${intl.get('utils_seconds')}`
    : `${addZero(second)}${intl.get('utils_seconds')}`;
};

export { intiTimeZoneStr, intlFormatDate, formatDate, seconds2Time, seconds2Minute };
